<template>
	<el-drawer v-bind="$attrs" v-on="$listeners">
		<template v-if="$slots.title" #title>
			<slot name="title"></slot>
		</template>

		<div class="drawer-content">
			<div class="drawer-content-view" ref="content">
				<slot></slot>
			</div>

			<div v-if="operates.length > 0" class="drawer-content-footer">
				<template
					v-for="(
						{ showTooltip, tooltipContent, tooltipConfig, permission, click, label, ...operate }, index
					) in operates"
				>
					<el-tooltip
						v-if="showTooltip && tooltipContent"
						effect="dark"
						:content="tooltipContent"
						:key="`${index}-${label}-${permission}`"
						v-bind="tooltipConfig"
					>
						<el-button :key="index" v-bind="operate" v-permission="permission" @click="click">
							{{ label }}
						</el-button>
					</el-tooltip>
					<el-button
						v-else
						:key="`${index}-${label}-${permission}`"
						v-bind="operate"
						v-permission="permission"
						@click="click"
					>
						{{ label }}
					</el-button>
				</template>
			</div>
		</div>
	</el-drawer>
</template>

<script>
/**
 * 符合当前ui样式的自定义抽屉组件
 * @param {Array} operates - 操作按钮
 * @param {Boolean} operates.loading - 按钮加载状态
 * @param {String} operates.size - 按钮大小
 * @param {String} operates.label - 按钮文本
 * @param {Boolean} operates.showTooltip - 按钮是否需要Tooltip提示，showTooltip和tooltipContent同时存在时才会显示Tooltip
 * @param {String} operates.tooltipContent - 按钮Tooltip提示内容
 * @param {String} operates.tooltipConfig - Tooltip其他配置项
 * @param {String} operates.permission - 按钮权限
 * @param {Function} operates.click - 按钮点击事件
 * @param {*} operates... - 泛指el-button的所有属性
 *
 * 接受element-ui Drawer组件的所有属性，事件和插槽
 */

export default {
	name: "XbdDrawer",
	inheritAttrs: false,
	props: {
		needScrollTop: {
			type: Boolean,
			default: true
		},
		operates: {
			type: Array,
			default: () => []
		}
	},
	watch: {
		"$attrs.visible": {
			handler(val) {
				if (this.needScrollTop && val) {
					this.$nextTick(() => {
						this.$refs.content.scrollTop = 0;
					});
				}
			},
			immediate: true
		}
	}
};
</script>

<style scoped lang="scss">
::v-deep .el-drawer__header {
	box-sizing: border-box;
	padding: 0 24px;
	margin: 0;
	border-bottom: 1px solid #e7e8eb;
	display: inline-flex;
	height: 56px;

	& > :first-child {
		flex: 1;
		color: #252a33;
		font-family: "PingFang SC";
		font-size: 16px;
		font-style: normal;
		font-weight: 600;
		line-height: 24px;
	}

	> :last-child {
		color: #74798a;
	}
}

::v-deep .el-drawer__body {
	overflow: hidden;
}

.drawer-content {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;

	&-view {
		flex: 1;
		overflow: auto;
		padding: 0;
		background: #fff;
	}

	&-footer {
		height: 56px;
		display: inline-flex;
		flex-direction: row;
		justify-content: flex-end;
		align-items: center;
		padding: 0 24px;
		border-top: 1px solid #e8e8e8;
	}
}
.el-button {
	font-size: 14px;
}
</style>
